import { PlaceSuggestionRow, SearchActionRow } from "./search-result-rows";

const MobileSearchResults = ({
  trimmedSearch,
  topPlace,
  visiblePlaceSuggestions,
  matchedRecentTerms,
  suggestionTerms,
  userLocation,
  isSuggestionLoading,
  onSubmit,
  onPlaceClick,
}) => (
  <div className="flex flex-col">
    {isSuggestionLoading &&
      !topPlace &&
      matchedRecentTerms.length === 0 &&
      suggestionTerms.length === 0 && (
      <SearchActionRow
        icon="line-md:loading-twotone-loop"
        label="검색 중..."
        muted
      />
    )}
    {visiblePlaceSuggestions.map((place) => (
      <PlaceSuggestionRow
        key={place?.id || place?._id || place?.placeUniqueNumber || place?.name}
        place={place}
        userLocation={userLocation}
        showDistance
        fallbackName="장소"
        onClick={() => onPlaceClick(place)}
      />
    ))}
    {matchedRecentTerms.map((term) => (
      <SearchActionRow
        key={`recent-${term}`}
        icon="lucide:clock"
        label={term}
        onClick={() => onSubmit(term)}
      />
    ))}
    {suggestionTerms.map((term) => (
      <SearchActionRow
        key={`suggestion-${term}`}
        icon="lucide:search"
        label={term}
        onClick={() => onSubmit(term)}
      />
    ))}
    {!isSuggestionLoading &&
      !topPlace &&
      matchedRecentTerms.length === 0 &&
      suggestionTerms.length === 0 && (
        <SearchActionRow
          icon="lucide:search"
          label={`${trimmedSearch} 검색`}
          onClick={() => onSubmit(trimmedSearch)}
        />
      )}
  </div>
);

export default MobileSearchResults;
